// extracted by mini-css-extract-plugin
export default {"table":"AccordionTable_table__hETVZ"};